export default __webpack_public_path__ + "static/media/red_4.8970c8a8.png";